import { Link } from "react-router-dom";
// Nhớ đổi tên file và đường dẫn video của bạn cho đúng nhé
import heroVideo from "@/assets/hero-video.mp4";

const HeroSection = () => {
    return (
        <section className="relative w-full h-[60vh] md:h-[80vh] overflow-hidden mt-[92px] md:mt-[120px]">

            {/* LỚP VIDEO NỀN */}
            <div className="absolute inset-0">
                <video
                    src={heroVideo}
                    autoPlay
                    loop
                    muted
                    playsInline
                    poster="/thumbnail-video-1.webp"
                    preload="none"
                    className="w-full h-full object-cover object-center"
                />
                {/* Lớp overlay làm tối video một chút để chữ trắng nổi bật lên */}
                <div className="absolute inset-0 bg-primary/30" />
            </div>

            {/* LỚP NỘI DUNG (CHỮ & NÚT BẤM) */}
            <div className="absolute inset-0 flex items-center justify-start">
                <div className="container mx-auto px-4">
                    <div className="max-w-xl nimate-fade-in">
                        <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading text-primary-foreground leading-tight whitespace-pre-line mb-4">
                            Memys - Điểm nhấn tinh tế <br />
                            cho không gian sống của bạn
                        </h1>
                        <Link
                            to="/san-pham/combo-da-khuech-tan-tinh-dau"
                            onClick={() => window.scrollTo(0, 0)}
                            className="inline-flex ml-1 mt-4 md:mt-8 px-4 md:px-6 lg:px-8 py-2 md:py-3 bg-primary text-primary-foreground text-xs md:text-sm tracking-widest uppercase hover:bg-primary-cyan transition-colors duration-300 min-h-[44px] items-center justify-center"
                        >
                            MUA NGAY
                        </Link>
                    </div>
                </div>
            </div>

        </section>
    );
};

export default HeroSection;